import { Component, OnInit } from '@angular/core';
import { ServiceTemplateMapping } from '../../models/service-template-map-model';
import { MatTableDataSource } from '@angular/material/table';
import { ServiceMasterService } from '../../services/service-master-service';
import { UtilityService } from 'src/app/modules/accounts-module/accounts/services/utility-service';
import { TemplateMasterService } from '../../services/template-master-service';
import { ServiceMasterModel } from '../../models/service-master-model';
import { Template } from '../../models/template-model';
import { ServiceTemplateMappingService } from '../../services/service-template-map-service';

@Component({
  selector: 'app-service-template-map',
  templateUrl: './service-template-map.component.html',
  styleUrls: ['./service-template-map.component.css']
})
export class ServiceTemplateMapComponent implements OnInit {

  public l_formData: ServiceTemplateMapping = new ServiceTemplateMapping();
  public isEditMode: boolean = false;
  private l_clientId: number;

  public dataSource = new MatTableDataSource<ServiceTemplateMapping>();
  public l_daybookFilteredList: ServiceTemplateMapping[] = [];
  public displayedColumns: string[] = [
    'srNo',
    'serviceName',
    'templateName',
    'isActive',
    'actions'
  ];

  public l_servicesList: ServiceMasterModel[] = [];
  public l_templatesList: Template[] = [];

  constructor(
    private l_ServiceMasterService: ServiceMasterService,
    private l_TemplateMasterService: TemplateMasterService,
    private l_UtilityService: UtilityService,
    private l_ServiceTemplateMappingService: ServiceTemplateMappingService
  ) {}

  async ngOnInit(): Promise<void> {
    const data = JSON.parse(sessionStorage.getItem('client_master'));
    this.l_clientId = data.clientId;
    // Defaults
    this.l_formData.isActive = 'YES';

    await this.lFN_GetServicesList();
    await this.lFN_GetTemplateList();
    await this.lFN_GetServiceTemplateMappingList();
  }

  async lFN_GetServicesList() {
    this.l_ServiceMasterService.lFN_GetServiceList().subscribe({
      next: (res) => {
        console.log("res service => ", res);
        this.l_servicesList = JSON.parse(res.body)?.data;
      },
      error: () => {
        this.l_UtilityService.lFN_ErrorToaster(
          'Failed to load services list',
          'Error'
        );
      }
    });
  }

  async lFN_GetTemplateList() {
    let l_response = this.l_TemplateMasterService.lFN_GetTemplateMasterList();
    l_response.subscribe({
      next: (res) => {
        console.log("res => ", res);
        this.l_templatesList = JSON.parse(res.body)?.data;
      },
      error: () => {
        this.l_UtilityService.lFN_ErrorToaster(
          'Failed to load template list',
          'Error'
        );
      }
    });
  }

  async lFN_GetServiceTemplateMappingList() {
    let l_response = this.l_ServiceTemplateMappingService.lFN_GetServiceTemplateMappingList();
    l_response.subscribe({
      next: (res) => {
        console.log("res => ", res);
        let responselist = JSON.parse(res.body);
        this.dataSource.data = responselist?.data;
      },
      error: () => {
        this.l_UtilityService.lFN_ErrorToaster(
          'Failed to fetch service template mapping list',
          'Error'
        );
      }
    });
  }

  lFN_SubmitForm() {
    console.log("l_formData => ", this.l_formData);
    let l_formDataObject = this.l_formData;
    if (l_formDataObject.templateId == null || l_formDataObject.serviceHeaderId == null) {
      this.l_UtilityService.lFN_WarningToaster('Please select values for template and service', 'Required fields missing');
      return;
    }
    // duplicacy check
    let l_isDuplicate = this.lFN_CheckDuplicate(l_formDataObject);
    console.log("l_isDuplicate ==> ", l_isDuplicate);
    if(l_isDuplicate == true) {
      this.l_UtilityService.lFN_WarningToaster('Service template mapping already exists', 'Duplicate Mapping');
      return;
    }

    let servicename = this.l_servicesList.find(s => s.serviceHeaderId == l_formDataObject.serviceHeaderId)?.serviceName;
    let templatename = this.l_templatesList.find(t => t.templateId === l_formDataObject.templateId)?.templateName;
    // set values
    l_formDataObject.clientId = this.l_clientId;
    l_formDataObject.serviceName = servicename;
    l_formDataObject.templateName = templatename;

    this.l_UtilityService.lFN_ShowLoader();
    let l_response = this.l_ServiceTemplateMappingService.lFN_SaveServiceTemplateMapping(l_formDataObject);
    l_response.subscribe({
      next: (res) => {
        console.log("l_response = ", res);
        if (res.status == 200) {
          this.l_UtilityService.lFN_SuccessToaster((res.body as any)?.message, 'Success');
          this.lFN_GetServiceTemplateMappingList();
          this.lFN_ResetForm();
        }
      },
      error: () => {
        this.l_UtilityService.lFN_ErrorToaster(
          'Failed to save service template mapping',
          'Error'
        );
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        this.l_UtilityService.lFN_HideLoader();
      }
    });
  }

  lFN_EditServiceTemplateMap(l_serviceTempMap: ServiceTemplateMapping) {
    this.l_formData = new ServiceTemplateMapping({ ...l_serviceTempMap });
    this.isEditMode = true;
  }

  lFN_ChangeServiceTemplateStatus(l_serviceTempMap: ServiceTemplateMapping) {}

  lFN_ResetForm() {
    this.isEditMode = false;
    this.l_formData = new ServiceTemplateMapping({ isActive: 'YES' });
  }

  lFN_CheckDuplicate(l_formDataObject: ServiceTemplateMapping) {
    console.log("this.dataSource.data => ", this.dataSource.data);
    let l_list = this.dataSource.data;
    let l_serviceTempMapObject = l_list.find(o => (o.serviceHeaderId === l_formDataObject.serviceHeaderId && o.templateId === l_formDataObject.templateId 
      && o.serviceTempId !== l_formDataObject.serviceTempId && o.isActive == 'YES'));
    console.log("l_serviceTempMapObject ==> ", l_serviceTempMapObject);
    if(l_serviceTempMapObject) {
      return true;
    } else {
      return false;
    }
  }

}
